import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

type HintPlacement = "top" | "right";

const bubblePlacement: Record<HintPlacement, string> = {
  top: "bottom-full left-1/2 mb-[7px] -translate-x-1/2",
  right: "left-full top-1/2 ml-[8px] -translate-y-1/2",
};

const InfoHint: React.FC<{ text: string; placement?: HintPlacement }> = ({
  text,
  placement = "top",
}) => (
  <span className="group/hint relative inline-flex cursor-help items-center">
    <FontAwesomeIcon
      icon={faCircleInfo}
      className="h-[12px] w-[12px] text-[rgba(144,158,177,0.43)] transition-colors group-hover/hint:text-slate-600"
    />
    <span
      className={`pointer-events-none absolute z-[60] w-max max-w-[230px] rounded-lg bg-slate-900 px-[10px] py-[6px] text-left font-['Hind',sans-serif] text-[11px] font-normal normal-case leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover/hint:opacity-100 ${bubblePlacement[placement]}`}
    >
      {text}
    </span>
  </span>
);

export default InfoHint;
